import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {issuerSettingsAPI} from "../api";
import {IUpsertIssuerSettings} from "../../../models/IIssuerSettings";

export const fetchGetIssuerSettings = createAsyncThunk(
    "issuer_settings/get",
    async (_, {rejectWithValue}) => {
        try {
            return await issuerSettingsAPI.get();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchUpsertIssuerSettings = createAsyncThunk(
    "issuer_settings/upsert",
    async (dto: IUpsertIssuerSettings, {rejectWithValue}) => {
        try {
            return await issuerSettingsAPI.upsert(dto);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);